import { useEffect, useState } from "react";
import { Menu, X, Phone, Users } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "@/lib/lenis";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NAV = [
  { id: "zakladatel", label: "O nás" },
  { id: "remeslnici", label: "Řemeslníci" },
  { id: "sluzby", label: "Služby" },
  { id: "projekty", label: "Projekty" },
  { id: "kabum-pro", label: "KABUM PRO" },
  { id: "kalkulacka", label: "Kalkulačka" },
  { id: "kontakt", label: "Kontakt" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [visitors, setVisitors] = useState(null);
  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  useEffect(() => {
    fetch(`${API}/visitors/track`, { method: "POST" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setVisitors(d.count))
      .catch(() => {});
  }, []);

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/70 border-b border-gold/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-20 flex items-center justify-between">
        <a href="#hero" onClick={go("hero")} data-testid="nav-logo-link" aria-label="RESTART PRO — domů">
          <Logo />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              onClick={go(n.id)}
              data-testid={`nav-link-${n.id}`}
              className="text-sm text-zinc-300 hover:text-gold transition-colors tracking-wide"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {visitors !== null && (
            <span
              data-testid="visitor-counter"
              className="hidden md:inline-flex items-center gap-1.5 text-xs font-mono text-zinc-500 border border-white/10 rounded-full px-3 py-2"
              title="Počet návštěvníků dnes (bez opakovaných návštěv ze stejné adresy)"
            >
              <Users size={13} className="text-gold/70" />
              dnes {visitors}
            </span>
          )}
          <a
            href="tel:+420777940118"
            data-testid="header-phone-cta"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-gold border border-gold/40 rounded-full px-4 py-2 hover:bg-gold hover:text-black transition-colors"
          >
            <Phone size={15} /> +420 777 940 118
          </a>
          <button
            className="lg:hidden text-zinc-200 p-1"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Přepnout menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden bg-black/95 border-t border-gold/10 px-6 py-5 flex flex-col gap-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              onClick={go(n.id)}
              data-testid={`mobile-nav-link-${n.id}`}
              className="text-zinc-200 hover:text-gold transition-colors"
            >
              {n.label}
            </a>
          ))}
          <a href="tel:+420777940118" data-testid="mobile-phone-cta" className="text-gold font-medium">
            +420 777 940 118
          </a>
          {visitors !== null && (
            <span
              data-testid="visitor-counter-mobile"
              className="inline-flex items-center gap-1.5 text-xs font-mono text-zinc-500"
            >
              <Users size={13} className="text-gold/70" />
              Dnes nás navštívilo {visitors} lidí
            </span>
          )}
        </div>
      )}
    </header>
  );
}
